import {
  TIMESLOTS_DEFAULT_PACKAGE_GET_REQUEST,
  TIMESLOTS_DEFAULT_PACKAGE_GET_SUCCESS,
  TIMESLOTS_DEFAULT_PACKAGE_GET_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';

export function getDefaultTimeSlotsPackage() {
  return {
    types: [
      TIMESLOTS_DEFAULT_PACKAGE_GET_REQUEST,
      TIMESLOTS_DEFAULT_PACKAGE_GET_SUCCESS,
      TIMESLOTS_DEFAULT_PACKAGE_GET_FAILURE,
    ],
    buildCallParameters: () => ({
      method: HTTP_METHOD.GET,
      path: 'v1/query/GetTimeSlotsDefaultPackage',
    }),
  };
}
